<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col hidden lg:block lg:w-1/2">
              <img src="@/assets/images/logo/itovi_blue.png" alt="login" class="mx-auto sm:w-3/4">
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">

                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Login</h4>
                </div>

                <div>
                  <vs-input
                      name="email"
                      :danger="input.errors.email.error"
                      :danger-text="input.errors.email.description"
                      icon-no-border
                      icon="icon icon-user"
                      icon-pack="feather"
                      label-placeholder="Email"
                      v-model="input.email"
                      class="w-full"/>

                  <vs-input
                      type="password"
                      name="password"
                      :danger="input.errors.password.error"
                      :danger-text="input.errors.password.description"
                      v-on:keydown.enter="login"
                      icon-no-border
                      icon="icon icon-lock"
                      icon-pack="feather"
                      label-placeholder="Password"
                      v-model="input.password"
                      class="w-full mt-6" />

                  <div class="flex flex-wrap justify-between my-5">
                      <router-link to="">Forgot Password?</router-link>
                  </div>

                  <vs-button :disabled="loading" @click="login">Login</vs-button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import api from '@/http/api';

export default {
  data() {
    return {
      valid: true,
      input: {
        email: "",
        password: "",
        errors: {
          email: {
            error: false,
            description: null
          },
          password: {
            error: false,
            description: null
          }
        }
      },
      passwordRules: [
        v => !!v || 'Password is required'
      ],
      emailRules: [
        v => !!v || 'Email is required',
        v => /.+@.+/.test(v) || 'email must be valid'
      ],
      loading: false
    }
  },
  methods: {
    async login() {
      this.loading = true;

      if (!this.validate()) {
        return;
      }

      let success = await api.login(this.input);
      this.loading = false;

      if (!success) {
        this.$vs.notify({
          position: 'top-center',
          color: 'danger',
          title: 'Error!',
          text: 'Failed to Login!'
        });
        return;
      }

      // this fails if the user landed on the login page from a redirect for some reason.
      this.$router.replace(this.$route.query.redirect || '/').catch(()=> {
        window.location = location.protocol+'//'+location.hostname+(location.port ? ':'+location.port: '');
      });

    },
    validate () {
      // todo: make this smart
      this.input.errors.email.error = false;
      this.input.errors.email.description = null;
      this.input.errors.password.error = false;
      this.input.errors.password.description = null;
      // validate email
      if (this.input.email.length < 1) {
        this.input.errors.email.error = true;
        this.input.errors.email.description = 'email is required';
      }
      if (!(/.+@.+/.test(this.input.email))) {
        this.input.errors.email.error = true;
        this.input.errors.email.description = 'invalid email';
      }

      // validate password
      if (this.input.password.length < 1) {
        this.input.errors.password.error = true;
        this.input.errors.password.description = 'password is required';
      }

      return !this.input.errors.email.error && !this.input.errors.password.error;
    },
    showErrors() {
      this.$vs.notify({
        position: 'top-center',
        title: 'Error',
        text:  'Credentials Invalid!',
        color: 'danger',
        icon: 'error'
      });
    }
  }
}
</script>

<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook { background-color: #1551b1 }
    .bg-twitter { background-color: #00aaff }
    .bg-google { background-color: #4285F4 }
    .bg-github { background-color: #333 }
  }
}
</style>
